import type { ICampaign } from "../Types/account";

export function getWorkspaceCampaignStorageKey(
  userId: string,
  clientId: string,
): string {
  return `workspaceCampaignId:${userId}:${clientId}`;
}

export function readStoredWorkspaceCampaignId(
  userId: string,
  clientId: string,
): string | null {
  try {
    const value = sessionStorage.getItem(
      getWorkspaceCampaignStorageKey(userId, clientId),
    );
    return value && value !== "" ? value : null;
  } catch {
    return null;
  }
}

export function writeStoredWorkspaceCampaignId(
  userId: string,
  clientId: string,
  campaignId: string,
): void {
  try {
    sessionStorage.setItem(
      getWorkspaceCampaignStorageKey(userId, clientId),
      campaignId,
    );
  } catch {
    // sessionStorage may be unavailable
  }
}

export function resolveWorkspaceCampaign(
  campaigns: ICampaign[],
  preferredCampaignId: string | null | undefined,
): ICampaign | null {
  if (preferredCampaignId) {
    const preferred = campaigns.find(
      (campaign) => campaign.id === preferredCampaignId,
    );
    if (preferred) return preferred;
  }
  return campaigns.find((campaign) => campaign.is_default) ?? campaigns[0] ?? null;
}
